import { useContext } from 'react';
import PostsContext from './context';

export const usePostsContext = () => useContext(PostsContext);
